module.exports = __webpack_public_path__ + "static/media/02_andinvainthedreamer.fb840dfc.jpg";